import dayjs from 'dayjs'

export default function daysSince (input: string) {
  const today = dayjs()
  const inputDate = dayjs(input)
  const difference = today.diff(inputDate, 'day')
  return Number.isNaN(difference) ? null : difference
}
